// extracted by mini-css-extract-plugin
export default {"ClockScreen":"ClockScreen_ClockScreen__+ie0l","Heading":"ClockScreen_Heading__TUJoE","Icon":"ClockScreen_Icon__j3pfo","ActionButton":"ClockScreen_ActionButton__W1V6J"};